import { MouseEvent, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faEllipsisVertical,
  faPenToSquare,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Popper from "components/Popper";
import { IBudgetExpense } from "dto/Budget/IBudgetExpense";
import styles from "./styles.module.scss";

interface Props {
  row: IBudgetExpense;
  onPreview: (row: IBudgetExpense) => void;
  onEdit: (row: IBudgetExpense) => void;
  onAddEngagement: (row: IBudgetExpense) => void;
}

const MenuCell = ({ row, onPreview, onEdit, onAddEngagement }: Props) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const run = (action: () => void) => (e: MouseEvent) => {
    e.stopPropagation();
    setOpen(false);
    action();
  };

  return (
    <div className={styles.cell} ref={ref}>
      <div
        className={styles.hover}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>

      <Popper open={open} anchorEl={ref.current} setOpen={setOpen}>
        <div className={styles.dropdown}>
          <div className={styles.dropdownItem} onClick={run(() => onPreview(row))}>
            <FontAwesomeIcon icon={faCircleInfo} />
            Podgląd
          </div>
          <div className={styles.dropdownItem} onClick={run(() => onEdit(row))}>
            <FontAwesomeIcon icon={faPenToSquare} />
            Edytuj
          </div>
          <div
            className={styles.dropdownItem}
            onClick={run(() => onAddEngagement(row))}
          >
            <FontAwesomeIcon icon={faPlus} />
            Dodaj zaangażowanie
          </div>
        </div>
      </Popper>
    </div>
  );
};

export default MenuCell;
